import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import capitalizeFirstLetter from "../../helpers/general";
import sitePictureReplacement from "../../img/school.png";
import InterestContext from "../../context/interest/interestContext";
import RegistrationContext from "../../context/registration/registrationContext";
// import UserContext from "../../context/users/userContext";
import CTE from "../../img/CTE.png";
import CLMI from "../../img/CLMI.png";
import { getsites } from "../findBrand";
import ErrorLogger from "../ErrorLogger";
import phoneIcon from ".././../img/phoneicon.png";
import placeholderLocationPic from "../../img/school.png";

export const SiteItem = ({ site }) => {
  const interestContext = useContext(InterestContext);
  const { setLearningCenter, learningCenterCoordinates,programTypesforweb } = interestContext;
  // const userContext = useContext(UserContext);
  // const { programTypes } = userContext;

  // State for mobile expansion
  const [isExpanded, setIsExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const brandName = getsites();
  // State for image handling
  const [imageError, setImageError] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  

  // Azure Blob Storage configuration
  // const blobEndpoint = import.meta.env.VITE_BLOB_ENDPOINT;
  // const blobSas = import.meta.env.VITE_BLOB_SAS;
  // const blobContainer = import.meta.env.VITE_BLOB_CONTAINER;


// Destructure other site fields
const {
  id,
  name,
  displayName,
  charter,
  photo,
  coordinates,
  distance,
} = site;

const getPrimaryAddress = () => {
  
  // First try to use addresses array if it exists and has items
  if (site.addresses && Array.isArray(site.addresses) && site.addresses.length > 0) {
    const primaryAddr = site.addresses.find((addr) => addr.isPrimary) || site.addresses[0];
        return {
      state: primaryAddr.state,
      address_1: primaryAddr.street || primaryAddr.address_1,
      address_2: primaryAddr.address_2 || '', 
      city: primaryAddr.city,
      phone: primaryAddr.phone || site.address?.phone || '', 
      fax: primaryAddr.fax || '', 
      zip: primaryAddr.zip,
      start_day: primaryAddr.start_day || '',
      end_day: primaryAddr.end_day || '',
      start_time: primaryAddr.start_time || '',
      end_time: primaryAddr.end_time || '',
      description: primaryAddr.description || '',
    };
  }
  
  // Fallback to legacy address structure
  return {
    state: site.address?.state || '',
    address_1: site.address?.address_1 || '',
    address_2: site.address?.address_2 || '',
    city: site.address?.city || '',
    phone: site.address?.phone || '',
    fax: site.address?.fax || '',
    zip: site.address?.zip || '',
    start_day: site.address?.start_day || '',
    end_day: site.address?.end_day || '',
    start_time: site.address?.start_time || '',
    end_time: site.address?.end_time || '',
    description: site.address?.description || '',
  };
};

// Destructure the primary address fields
const {
  state,
  address_1,
  address_2,
  city,
  phone,
  zip,
  start_day,
  end_day,
  start_time,
  end_time,
} = getPrimaryAddress();

  const registrationContext = useContext(RegistrationContext);

  // Function to handle image load error
  const handleImageError = () => {
    console.error("Failed to load image:", photo);
    ErrorLogger.logError(`Failed to load image for site ${name}: ${photo}`);
    setImageError(true);
    setImageLoading(false);
    setImageSrc(placeholderLocationPic);
  };

  // Function to handle image load success
  const handleImageLoad = () => {
    setImageLoading(false);
    setImageError(false);
  };

  // Update image src when photo prop changes
  useEffect(() => {
    if (photo && photo !== "") {
      setImageSrc(photo);
      setImageError(false);
      setImageLoading(true);
    } else {
      setImageSrc(placeholderLocationPic);
      setImageError(false);
      setImageLoading(false);
    }
  }, [photo]);
  const [imageSrc, setImageSrc] = useState(photo || placeholderLocationPic);

 
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);


    return () => window.removeEventListener("resize", checkMobile);
  }, []);
 

  // Reset expansion when switching between mobile/desktop
  useEffect(() => {
    if (!isMobile) {
      setIsExpanded(false);
    }
  }, [isMobile]);

  const getFilteredPrograms = () => {
    // Make sure programTypes is an array
    if (!Array.isArray(programTypesforweb) || programTypesforweb.length === 0) return [];

    const programMap = {
      "Career Technical Education": {
        displayName: "CTE",
        icon: (
          <img src="https://locationsappstorage.blob.core.windows.net/icons/cte.webp" />
        ),
        className: "cte-icon",
        order: 1,
      },
      "CLMI Fellowship": {
        displayName: "CLMI",
        icon: (
          <img src="https://locationsappstorage.blob.core.windows.net/icons/clmi.webp" />
        ),
        className: "clmi-icon",
        order: 2,
      },
      WIOA: {
        displayName: "WIOA",
        icon: (
          <img src="https://locationsappstorage.blob.core.windows.net/icons/wioa.svg" />
        ),
        className: "wioa-icon",
        order: 3,
      },
      HOPE: {
        displayName: "HOPE",
        icon: (
          <img src="https://locationsappstorage.blob.core.windows.net/icons/hope.svg" />
        ),
        className: "hope-icon",
        order: 4,
      },
    };

    const desiredOrder = [
      "Career Technical Education",
      "CLMI Fellowship",
      "WIOA",
      "HOPE",
    ];

    return desiredOrder
      .map((programName) => {
        const program = programTypesforweb.find((p) => p.name === programName);
        if (program && programMap[program.name]) {
          // Check if program has brand information and if it matches the current brand (case-insensitive)
          const programBrand =
            program.brand && program.brand[0] && program.brand[0].brandName;
          const shouldShowProgram =
            programBrand &&
            brandName &&
            programBrand.toLowerCase() === brandName.toLowerCase();

          if (shouldShowProgram) {
            return {
              ...program,
              ...programMap[program.name],
              url: program.brand[0].url || null,
            };
          }
        }
        return null;
      })
      .filter((program) => program !== null);
  };

  // Function to handle program click and open URL
  const handleProgramClick = (program) => {
    if (program.url) {
      window.open(program.url, "_blank");
    }
  };

  const isValidPhone = (phoneNumber) => {
    // Basic phone validation - adjust regex as needed
    const phoneRegex = /^[\+]?[\d\s\-\(\)]{7,}$/;
    return phoneRegex.test(phoneNumber.trim());
  };

  const handleSiteClick = () => {
    document
      .getElementById(`site-${id}`)
      .scrollIntoView({ behavior: "smooth" });
    setLearningCenter({
      name,
      charter,
      coordinates,
      address: `${address_1}, ${city}, ${state}, ${zip}`,
    });
    registrationContext.setLearningCenter({
      name,
      charter,
      coordinates,
      address: `${address_1}, ${city}, ${state}, ${zip}`,
    });
  };

  const handleSeeMoreInfo = (e) => {
    e.stopPropagation();
    setIsExpanded(true);
  };

  const filteredPrograms = getFilteredPrograms();
  const hasPrograms = filteredPrograms.length > 0;

  return (
    <div id={`site-${id}`} className="item-container">
      <div
        className={`site-item ${isMobile && isExpanded ? "expanded" : ""} ${
          isMobile && !isExpanded ? "minimized" : ""
        }`}
        style={{
          border: coordinates === learningCenterCoordinates ? "" : "white",
        }}
        onClick={handleSiteClick}
      >
        {/* <div className={`left ${isMobile && !isExpanded ? 'mobile-hidden' : ''}`}>
  <img src={photo === "" ? sitePictureReplacement : photo} alt={`${name} location`} />
  {distance && (
    <div className="bottom-overlay">
      <span>{`${distance} miles away`}</span>
    </div>
  )}
</div> */}
        {/* New Photo from azure blob*/}
        <div
          className={`left ${isMobile && !isExpanded ? "mobile-hidden" : ""}`}
        >
          {imageLoading && <div className="image-loading">Loading...</div>}
          {/* {imageError && (
placeholderLocationPic
          )} */}
          <img
            className="site-image"
            src={imageSrc}
            alt={`${name} location`}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
          {distance && (
            <div className="bottom-overlay">
              <span>{`${distance} miles away`}</span>
            </div>
          )}
        </div>

        {/* Right section - Content */}
        <div className="right">
          {/* Always visible content on mobile and desktop */}
          <h3 className="site-title">{`${name}`}</h3>
          <h3 className="site-title">{`${charter}`}</h3>

         <h4>Address:</h4>
<p>{`${address_1}, ${city}, ${state}, ${zip}`}</p>
{address_2 && <p>{`${address_2}`}</p>} {/* Display address_2 if it exists */}


       <h4>Hours:</h4>
<p>{`${capitalizeFirstLetter(start_day)} - ${capitalizeFirstLetter(end_day)} from ${start_time} - ${end_time}`}</p>

          {/* Phone section - hidden on mobile when minimized, always visible on desktop */}
          {/* <div className={`phone-section ${isMobile && !isExpanded ? 'mobile-hidden' : ''}`}>
  <a href={`tel:${phone}`} style={{ color: '#007bff', textDecoration: 'none', fontSize: '12px' }}>
    <FaIcons.FaPhone className="phone-icon" /> {phone}
  </a>
</div> */}

          <div
            className={`phone-section ${
              isMobile && !isExpanded ? "mobile-hidden" : ""
            }`}
          >
            {phone && phone.trim() !== "" && isValidPhone(phone) ? (
              <a
                href={`tel:${phone}`}
                style={{
                  color: "#007bff",
                  textDecoration: "none",
                  fontSize: "12px",
                }}
              >
                {/* <FaIcons.FaPhone className="phone-icon" /> {phone} */}
                {/* <img src={phoneIcon} className="phone-icon" /> {phone} */}
                   <span >
      <img src={phoneIcon} className="phone-icon" /> {phone}
      {/* <FaIcons.FaPhone className="phone-icon" /> {phone} */}
      </span>
              </a>
            ) : (
              <span
                style={{
                  color: "##007bff",
                  textDecoration: "none",
                  fontSize: "12px",
                }}
              >
                {/* <FaIcons.FaPhone className="phone-icon" /> */}
              </span>
            )}
          </div>
          {/* Programs section - only show if there are matching programs */}
          {hasPrograms && (
            <div
              className={`programs-section ${
                isMobile && !isExpanded ? "mobile-hidden" : ""
              }`}
            >
              <h4 className="programs-title">Our Programs</h4>
              <div className="programs-grid">
                {filteredPrograms.map((program) => (
                  <div
                    key={program._id}
                    className="program-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleProgramClick(program);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={`program-icon ${program.className}`}>
                      {program.icon}
                    </div>
                    <div className="program-name">{program.displayName}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Bottom section with buttons */}
          <div className="bottom">
            {/* Mobile: Show "See More Info" when minimized, "View Site Info" when expanded */}
            {isMobile ? (
              !isExpanded ? (
                <button
                  className="btn btn-see-more"
                  onClick={handleSeeMoreInfo}
                  aria-label="See more information about this location"
                >
                  See More Info
                </button>
              ) : (
                <Link
                  to={`/information?site=${id}`}
                  className="btn btn-l4l-yellow btn-site-info"
                  onClick={(e) => {
                    e.stopPropagation();
                    window.scrollTo(0, 0);
                  }}
                >
                  View Site Info
                </Link>
              )
            ) : (
              /* Desktop: Always show "View Site Info" */
              <Link
                to={`/information?site=${id}`}
                className="btn btn-l4l-yellow btn-site-info"
                onClick={(e) => {
                  e.stopPropagation();
                  window.scrollTo(0, 0);
                }}
              >
                View Site Info
              </Link>
            )}
          </div>
        </div>
      </div>

      <div className="marker-selection">
        {/* Marker selection removed as requested */}
      </div>
    </div>
  );
};

export default SiteItem;
